export const data = new Object(
    {
        "version60": {
            "totalGroups":1,
            "groups":[
                {
                    "groupNumber":1,
                    "migrationId":"96c70634-c443-43d1-8887-d33176b3422c",
                    "data":{
                        "defaultDataJson": {
                            "ledgers":[{"accountId":"86d0b540-a5b1-42a8-a1ca-eca89b5e1731","title":null,"name":"Profit & Loss A/c","description":null,"groupTypeId":103,"accountGroupId":null,"routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
                            "migrationInfoItems": [{"migrationId":"96c70634-c443-43d1-8887-d33176b3422c", "migrationNumber":60, "groupNumber":1, "totalGroupNumber":1}]
                        }
                    }
                }
            ]
        },
        "version61": {
            "totalGroups":1,
            "groups":[
                {
                    "groupNumber":1,
                    "migrationId":"44d28bb1-0129-4c17-800f-41836e5e3311",
                    "data":{
                        "defaultDataJson": {
                            "units":[{"unitId":"b4889cad-14d4-1679-e470-5789a48ce138","shortName":"Pcs","decimalPlaces":null,"baseUnitId":"b4889cad-14d4-1679-e470-5789a48ce138","conversionType":101,"conversionQuantity":null,"status":1,"name":"Pcs","modifiedOn":null,"title":null,"unitQuantityCode":28,"versionId":null,"isSystem":1},{"unitId":"f97e596f-9026-aa52-85c9-d02c8c65b327","shortName":null,"decimalPlaces":null,"baseUnitId":"f97e596f-9026-aa52-85c9-d02c8c65b327","conversionType":101,"conversionQuantity":null,"status":1,"name":"Kg","modifiedOn":null,"title":null,"unitQuantityCode":20,"versionId":null,"isSystem":1},{"unitId":"ae12f4a5-186d-c294-24ea-70502712726d","shortName":null,"decimalPlaces":null,"baseUnitId":"ae12f4a5-186d-c294-24ea-70502712726d","conversionType":101,"conversionQuantity":null,"status":1,"name":"Litre","modifiedOn":null,"title":null,"unitQuantityCode":21,"versionId":null,"isSystem":1}],
                            "migrationInfoItems": [{"migrationId":"44d28bb1-0129-4c17-800f-41836e5e3311", "migrationNumber":61, "groupNumber":1, "totalGroupNumber":1}]
                        }
                    }
                }
            ]
        },
        "version78": {
            "totalGroups":1,
            "groups":[
                {
                    "groupNumber":1,
                    "migrationId":"f0fb8509-061d-4750-b300-7c464a88838f",
                    "data":{
                        "defaultDataJson": {
                            "transactionsType":[{"accountData":null,"additionalData":null,"central":true,"centralTransactionAccountId":null,"fieldsData":null,"importExport":false,"importExportTransactionAccountId":null,"inventory":0,"invoiceType":1,"isAllPartySelected":false,"isRouteApplicable":false,"local":true,"localTransactionAccountId":null,"name":"Expense","numberSeriesId":"8dae59f9-6aec-4791-ee7c-d877914ef70a","paymentMode":1,"salesGroupType":null,"taxMode":null,"title":"Expense","tradingType":0,"transactionNature":null,"transactionTypeFormId":"6b332fcd-59f7-28db-845c-06d7a8613f78","transactionTypeId":20005,"isSystem":1,"isDefault":true}],
                            "printTemplates":[{"businessLogo":true,"isHidden":false,"name":"Expense","printTemplateId":"db7c09d0-8f6c-407d-a69c-113ff865ec08","templateType":1,"theme":"theme_light","invoiceTemplate":1,"themeColor":"rgba(211,211,211,0.4)","tableRowColor":"ghostwhite","tableRowBorder":true,"alternateRowColor":true,"isSystem":1}],
                            "migrationInfoItems": [{"migrationId":"f0fb8509-061d-4750-b300-7c464a88838f", "migrationNumber":78, "groupNumber":1, "totalGroupNumber":1}]
                        }
                    }
                }
            ]
        },
// transaction type wise number series migration data
        "version109": {
            "totalGroups":1,
            "groups":[
                {
                    "groupNumber":1,
                    "migrationId":"ea71ac25-eed3-4a1a-ab39-a8ff7f3cbe2a",
                    "data":{
                        "defaultDataJson": {
                            "numberSeries":[{"numberSeriesId":"a431fe26-0dc5-4e6d-981d-45bd1ce24a3b","name":"Retail Invoice","isSystem":1},{"numberSeriesId":"690f3302-ce57-4439-b739-b90d1d257789","name":"Wholesale Invoice","isSystem":1},{"numberSeriesId":"db95e074-d5e6-43c4-af4e-41e7cb101d84","name":"Export Invoice","isSystem":1}],
                            "transactionNumbers":[{"transactionNumberId":"eddced04-3014-46b3-8195-61edf6be320c","fiscalYear":"2021","nextNumber":"001","prefix":"RINV","suffix":null,"numberSeriesId":"a431fe26-0dc5-4e6d-981d-45bd1ce24a3b","isSystem":1},{"transactionNumberId":"32db2b6d-bac4-4fe8-a52c-dd244d5973f4","fiscalYear":"2022","nextNumber":"001","prefix":"RINV","suffix":null,"numberSeriesId":"a431fe26-0dc5-4e6d-981d-45bd1ce24a3b","isSystem":1},{"transactionNumberId":"909db411-947d-4a3e-95c7-2cf1a946e7e7","fiscalYear":"2023","nextNumber":"001","prefix":"RINV","suffix":null,"numberSeriesId":"a431fe26-0dc5-4e6d-981d-45bd1ce24a3b","isSystem":1},{"transactionNumberId":"9ffd50e9-3f60-4413-8b5e-dbdce61dcd75","fiscalYear":"2024","nextNumber":"001","prefix":"RINV","suffix":null,"numberSeriesId":"a431fe26-0dc5-4e6d-981d-45bd1ce24a3b","isSystem":1},{"transactionNumberId":"17bc9c60-0e00-4392-8b17-6009d3550254","fiscalYear":"2025","nextNumber":"001","prefix":"RINV","suffix":null,"numberSeriesId":"a431fe26-0dc5-4e6d-981d-45bd1ce24a3b","isSystem":1},{"transactionNumberId":"a7ef2333-7f9d-4f22-8bab-e016d6741293","fiscalYear":"2021","nextNumber":"001","prefix":"WINV","suffix":null,"numberSeriesId":"690f3302-ce57-4439-b739-b90d1d257789","isSystem":1},{"transactionNumberId":"48aac223-9d0c-4e92-b924-5d34188ebcfd","fiscalYear":"2022","nextNumber":"001","prefix":"WINV","suffix":null,"numberSeriesId":"690f3302-ce57-4439-b739-b90d1d257789","isSystem":1},{"transactionNumberId":"f8065f5c-eace-47cc-a0de-1ff952f4a3b2","fiscalYear":"2023","nextNumber":"001","prefix":"WINV","suffix":null,"numberSeriesId":"690f3302-ce57-4439-b739-b90d1d257789","isSystem":1},{"transactionNumberId":"9e60c246-ead6-4525-86e1-a141485512a9","fiscalYear":"2024","nextNumber":"001","prefix":"WINV","suffix":null,"numberSeriesId":"690f3302-ce57-4439-b739-b90d1d257789","isSystem":1},{"transactionNumberId":"f1fea3dc-2c55-4d04-b743-ff6d1972c776","fiscalYear":"2025","nextNumber":"001","prefix":"WINV","suffix":null,"numberSeriesId":"690f3302-ce57-4439-b739-b90d1d257789","isSystem":1},{"transactionNumberId":"d9e2c6bc-0dd4-4117-a417-660e04ef5d59","fiscalYear":"2021","nextNumber":"001","prefix":"EINV","suffix":null,"numberSeriesId":"db95e074-d5e6-43c4-af4e-41e7cb101d84","isSystem":1},{"transactionNumberId":"82a6bba9-93f8-46aa-a242-c7aa69e64c04","fiscalYear":"2022","nextNumber":"001","prefix":"EINV","suffix":null,"numberSeriesId":"db95e074-d5e6-43c4-af4e-41e7cb101d84","isSystem":1},{"transactionNumberId":"93f6fe18-9e6a-409f-89ce-3c2b4502c51d","fiscalYear":"2023","nextNumber":"001","prefix":"EINV","suffix":null,"numberSeriesId":"db95e074-d5e6-43c4-af4e-41e7cb101d84","isSystem":1},{"transactionNumberId":"8f0f2cdd-3c38-4dca-8e29-86e4dbd32e6b","fiscalYear":"2024","nextNumber":"001","prefix":"EINV","suffix":null,"numberSeriesId":"db95e074-d5e6-43c4-af4e-41e7cb101d84","isSystem":1},{"transactionNumberId":"d9aaee48-67a4-43fb-b589-0b9992c90a23","fiscalYear":"2025","nextNumber":"001","prefix":"EINV","suffix":null,"numberSeriesId":"db95e074-d5e6-43c4-af4e-41e7cb101d84","isSystem":1}],
                            "migrationInfoItems": [
                                {
                                    "migrationId":"ea71ac25-eed3-4a1a-ab39-a8ff7f3cbe2a", 
                                    "migrationNumber":109, 
                                    "groupNumber":1, 
                                    "totalGroupNumber":1
                                }
                            ]
                        }
                    }
                }
            ]
        },
    }

    // {
    // "version41": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"0e61ae2b-72f3-41d3-bd63-5bbaf7930443",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"7f9a9f49-7f06-4095-b8dc-751fe3ccbb63","name":"Test Account Group 2","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"0e61ae2b-72f3-41d3-bd63-5bbaf7930443", "migrationNumber":41, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"83cb51c0-5b8b-4e1b-8690-2595fcf09f2d",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"783a70ee-d2ba-4f72-b2c6-4591761c2f0c","title":null,"name":"Test Ledger 2","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"83cb51c0-5b8b-4e1b-8690-2595fcf09f2d", "migrationNumber":41, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version42": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"26d6179f-8f5d-4f3d-94f3-d3d4c8400971",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"45df0d61-3c9a-4a65-a1b3-a1f783ed412e","name":"Test Account Group 3","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"26d6179f-8f5d-4f3d-94f3-d3d4c8400971", "migrationNumber":42, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"83e16251-eba1-44f8-987f-7b974bfc921a",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"315f2bc6-f749-4868-b713-ee1da4b9d57a","title":null,"name":"Test Ledger 3","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"83e16251-eba1-44f8-987f-7b974bfc921a", "migrationNumber":42, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version43": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"62bb85bd-364c-426c-8433-775ef502709b",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"03af72f9-7848-458a-8a8d-56de37f3a6e0","name":"Test Account Group 4","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"62bb85bd-364c-426c-8433-775ef502709b", "migrationNumber":43, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"8b2888ca-4ee3-4328-9b8e-94d61d07cc98",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"2e9baa89-2fd5-4791-bd2e-b80c955d2f22","title":null,"name":"Test Ledger 4","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"8b2888ca-4ee3-4328-9b8e-94d61d07cc98", "migrationNumber":43, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version44": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"8e125975-1c8c-400c-9c13-4acffda560b4",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"d791ade8-9a9d-4525-95af-35ed804dfe87","name":"Test Account Group 5","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"8e125975-1c8c-400c-9c13-4acffda560b4", "migrationNumber":44, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"89cb1b4c-446c-4048-8c15-1d0999ff08a4",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"3d1e46fd-16d0-4ad4-9156-704299188440","title":null,"name":"Test Ledger 5","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"89cb1b4c-446c-4048-8c15-1d0999ff08a4", "migrationNumber":44, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version45": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"eabcf1a0-b1a9-4745-a4f8-52c227c781e0",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"fff6fef9-40e2-469e-91cc-b1b529e8317c","name":"Test Account Group 6","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"eabcf1a0-b1a9-4745-a4f8-52c227c781e0", "migrationNumber":45, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"f78953aa-e126-4dcc-a4f5-264fabda9064",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"3d091818-0165-4f0e-86fb-9dde31dd42ce","title":null,"name":"Test Ledger 6","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"f78953aa-e126-4dcc-a4f5-264fabda9064", "migrationNumber":45, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version46": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"502b6676-59d0-49fb-b7cd-800ad0cc22dc",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"357e4d1e-86ef-4975-9d0f-6e80531a6c59","name":"Test Account Group 7","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"502b6676-59d0-49fb-b7cd-800ad0cc22dc", "migrationNumber":46, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"32893dee-6734-4a30-9069-9e703e26a090",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"37fbd4a5-e789-484a-a80d-6a5ad80f3ef7","title":null,"name":"Test Ledger 7","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"32893dee-6734-4a30-9069-9e703e26a090", "migrationNumber":46, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version47": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"2a280960-9360-43e5-9a83-51fa7d2d31b7",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"e7d275bb-afd7-4874-98a3-6bbba983826c","name":"Test Account Group 8","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"2a280960-9360-43e5-9a83-51fa7d2d31b7", "migrationNumber":47, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"76eb687c-a7e1-48e7-b81a-079e9c2cd91c",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"5150ac22-180a-4153-bbf6-aad2913caa70","title":null,"name":"Test Ledger 8","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"76eb687c-a7e1-48e7-b81a-079e9c2cd91c", "migrationNumber":47, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version48": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"d7457e16-8d07-478c-a2a4-3aaafa68916a",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"7627a4d9-764a-4e42-9f24-a4d6357a70e9","name":"Test Account Group 9","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"d7457e16-8d07-478c-a2a4-3aaafa68916a", "migrationNumber":48, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"20d034a2-7dd5-4f96-bd70-49960ec5d66a",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"ab2d5f74-549c-48a9-ac9d-e9df395b3620","title":null,"name":"Test Ledger 9","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"20d034a2-7dd5-4f96-bd70-49960ec5d66a", "migrationNumber":48, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version49": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"b91b13c2-9d76-47c2-b1a6-d709b4250819",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"0cbfe29d-4f28-467a-8dfb-9808c14006e3","name":"Test Account Group 10","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"b91b13c2-9d76-47c2-b1a6-d709b4250819", "migrationNumber":49, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"65282fc9-e3d8-4bd9-8acf-9d5b06687362",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"5a95f083-8596-40cd-904e-375fbfba2172","title":null,"name":"Test Ledger 10","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"65282fc9-e3d8-4bd9-8acf-9d5b06687362", "migrationNumber":49, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // }
    
    // "version2": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"0e61ae2b-72f3-41d3-bd63-5bbaf7930443",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"7f9a9f49-7f06-4095-b8dc-751fe3ccbb63","name":"Test Account Group 2","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"0e61ae2b-72f3-41d3-bd63-5bbaf7930443", "migrationNumber":2, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"83cb51c0-5b8b-4e1b-8690-2595fcf09f2d",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"783a70ee-d2ba-4f72-b2c6-4591761c2f0c","title":null,"name":"Test Ledger 2","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"83cb51c0-5b8b-4e1b-8690-2595fcf09f2d", "migrationNumber":2, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version3": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"26d6179f-8f5d-4f3d-94f3-d3d4c8400971",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"45df0d61-3c9a-4a65-a1b3-a1f783ed412e","name":"Test Account Group 3","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"26d6179f-8f5d-4f3d-94f3-d3d4c8400971", "migrationNumber":3, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"83e16251-eba1-44f8-987f-7b974bfc921a",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"315f2bc6-f749-4868-b713-ee1da4b9d57a","title":null,"name":"Test Ledger 3","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"83e16251-eba1-44f8-987f-7b974bfc921a", "migrationNumber":3, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version4": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"62bb85bd-364c-426c-8433-775ef502709b",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"03af72f9-7848-458a-8a8d-56de37f3a6e0","name":"Test Account Group 4","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"62bb85bd-364c-426c-8433-775ef502709b", "migrationNumber":4, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"8b2888ca-4ee3-4328-9b8e-94d61d07cc98",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"2e9baa89-2fd5-4791-bd2e-b80c955d2f22","title":null,"name":"Test Ledger 4","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"8b2888ca-4ee3-4328-9b8e-94d61d07cc98", "migrationNumber":4, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version5": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"8e125975-1c8c-400c-9c13-4acffda560b4",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"d791ade8-9a9d-4525-95af-35ed804dfe87","name":"Test Account Group 5","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"8e125975-1c8c-400c-9c13-4acffda560b4", "migrationNumber":5, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"89cb1b4c-446c-4048-8c15-1d0999ff08a4",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"3d1e46fd-16d0-4ad4-9156-704299188440","title":null,"name":"Test Ledger 5","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"89cb1b4c-446c-4048-8c15-1d0999ff08a4", "migrationNumber":5, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version6": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"eabcf1a0-b1a9-4745-a4f8-52c227c781e0",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"fff6fef9-40e2-469e-91cc-b1b529e8317c","name":"Test Account Group 6","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"eabcf1a0-b1a9-4745-a4f8-52c227c781e0", "migrationNumber":6, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"b424efab-d0c9-4244-bbe8-73d6ba56137f",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"3d091818-0165-4f0e-86fb-9dde31dd42ce","title":null,"name":"Test Ledger 6","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"b424efab-d0c9-4244-bbe8-73d6ba56137f", "migrationNumber":6, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version7": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"502b6676-59d0-49fb-b7cd-800ad0cc22dc",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"357e4d1e-86ef-4975-9d0f-6e80531a6c59","name":"Test Account Group 7","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"502b6676-59d0-49fb-b7cd-800ad0cc22dc", "migrationNumber":7, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"32893dee-6734-4a30-9069-9e703e26a090",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"37fbd4a5-e789-484a-a80d-6a5ad80f3ef7","title":null,"name":"Test Ledger 7","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"32893dee-6734-4a30-9069-9e703e26a090", "migrationNumber":7, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version8": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"2a280960-9360-43e5-9a83-51fa7d2d31b7",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"e7d275bb-afd7-4874-98a3-6bbba983826c","name":"Test Account Group 8","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"2a280960-9360-43e5-9a83-51fa7d2d31b7", "migrationNumber":8, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"76eb687c-a7e1-48e7-b81a-079e9c2cd91c",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"5150ac22-180a-4153-bbf6-aad2913caa70","title":null,"name":"Test Ledger 8","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"76eb687c-a7e1-48e7-b81a-079e9c2cd91c", "migrationNumber":8, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version9": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"d7457e16-8d07-478c-a2a4-3aaafa68916a",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"7627a4d9-764a-4e42-9f24-a4d6357a70e9","name":"Test Account Group 9","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"d7457e16-8d07-478c-a2a4-3aaafa68916a", "migrationNumber":9, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"20d034a2-7dd5-4f96-bd70-49960ec5d66a",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"ab2d5f74-549c-48a9-ac9d-e9df395b3620","title":null,"name":"Test Ledger 9","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"20d034a2-7dd5-4f96-bd70-49960ec5d66a", "migrationNumber":9, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // },
    // "version10": {
    //     "totalGroups":2,
    //     "groups":[
    //         {
    //             "groupNumber":1,
    //             "migrationId":"b91b13c2-9d76-47c2-b1a6-d709b4250819",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "accountGroups":[{"accountGroupId":"0cbfe29d-4f28-467a-8dfb-9808c14006e3","name":"Test Account Group 10","title":null,"description":null,"groupTypeId":501,"isPrimaryAccountGroup":true,"parentAccountGroupId":null,"nature":101,"isEditable":1,"runningCustomerGroup":false,"acRefDetails":false,"otherDetails":null,"isSystem":1, "status":1}],
    //                     "migrationInfoItems": [{"migrationId":"b91b13c2-9d76-47c2-b1a6-d709b4250819", "migrationNumber":10, "groupNumber":1, "totalGroupNumber":2}]
    //                 }
    //             }
    //         },
    //         {
    //             "groupNumber":2,
    //             "migrationId":"65282fc9-e3d8-4bd9-8acf-9d5b06687362",
    //             "data":{
    //                 "defaultDataJson": {
    //                     "ledgers":[{"accountId":"5a95f083-8596-40cd-904e-375fbfba2172","title":null,"name":"Test Ledger 10","description":null,"groupTypeId":103,"accountGroupId":"f9dc5ac6-68bb-45b2-941b-87e8f1536a37","routeId":null,"stateId":null,"email":null,"phone":null,"mobile":null,"primaryMobileNumber":null,"gstType":null,"gstNumber":null,"panNumber":null,"currency":null,"placeOfSupplyId":null,"placeOfSupply":null,"countryId":null,"isEditable":0,"printDetails":null,"isSystem":1}],
    //                     "migrationInfoItems": [{"migrationId":"65282fc9-e3d8-4bd9-8acf-9d5b06687362", "migrationNumber":10, "groupNumber":2, "totalGroupNumber":2}]
    //                 }
    //             }
    //         }
    //     ]
    // }
    // }
)


// WEBPACK FOOTER //
// ./src/migration_data.js